import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Vconsole from "vconsole";
import { isDev } from "./config.js";
import { createPinia } from "pinia";
import "./styles/element-override.scss";
import { createHead } from "@unhead/vue";

const app = createApp(App);
const head = createHead();

const pinia = createPinia();

app.use(pinia);
app.use(head);
app.use(router);

if (isDev) {
  new Vconsole();
  // app.use(vconsole);
}

app.mount("#app");
